export default __webpack_public_path__ + "static/media/checkboxIcon.1a16c69c.svg";